// extracted by mini-css-extract-plugin
export default {"container":"Winning_container__snGr5","title":"Winning_title__tS5EU","user":"Winning_user__g9JSy","btn":"Winning_btn__QP3C1"};